import React from 'react';
import { Helmet } from 'react-helmet';

import { makeStyles, useTheme } from '@material-ui/core/styles';

import ProjectShell from '@hydra/common/shell/ProjectShell';
import TrialDialog from '@hydra/routes/trial-ended/components/TrialDialog';
import { useI18n } from '@hydra/common/customHooks';
import { DudaProject } from '@hydra/types';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column'
  }
}));

interface TrafficContainerProps {
  children?: React.ReactElement
  data: {
    favicon?: string | null
    dudaProject: DudaProject | null
  }
}

const TrafficContainer = ({ children, data }: TrafficContainerProps) => {
  const dudaProject = data && data.dudaProject ? data.dudaProject : null;
  const favicon = data && data.favicon ? data.favicon : null;
  const { translate } = useI18n();
  const theme = useTheme();
  const classes = useStyles();

  return (
    <ProjectShell
      section='traffic'
      favicon={favicon}
      bgColor={theme.palette.background.secondary}
      className={classes.root}
      dudaProject={dudaProject}
    >
      <Helmet>
        <title>{translate('traffic')}</title>
      </Helmet>
      <TrialDialog dudaProject={dudaProject} />
      {children}
    </ProjectShell>
  );
};

export default TrafficContainer;
